import { render, staticRenderFns } from "./CampaignTask.vue?vue&type=template&id=24133e56&"
import script from "./CampaignTask.vue?vue&type=script&lang=js&"
export * from "./CampaignTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports